export interface Letter {
  letter: string;
  word: string;
  meaning?: string;
}

export const uyirLetters: Letter[] = [
  { letter: 'அ', word: 'அம்மா', meaning: 'Mother' },
  { letter: 'அ', word: 'அரசு', meaning: 'Government' },
  { letter: 'அ', word: 'அழகு', meaning: 'Beauty' },
  { letter: 'ஆ', word: 'ஆடு', meaning: 'Goat' },
  { letter: 'ஆ', word: 'ஆடல்', meaning: 'Dance' },
  { letter: 'ஆ', word: 'ஆமை', meaning: 'Tortoise' },
  { letter: 'இ', word: 'இலை', meaning: 'Leaf' },
  { letter: 'இ', word: 'இரவு', meaning: 'Night' },
  { letter: 'இ', word: 'இடம்', meaning: 'Place' },
  { letter: 'ஈ', word: 'ஈட்டி', meaning: 'Spear' },
  { letter: 'ஈ', word: 'ஈசல்', meaning: 'Fly' },
  { letter: 'ஈ', word: 'ஈரம்', meaning: 'Wet' },
  { letter: 'உ', word: 'உதடு', meaning: 'Lip' },
  { letter: 'உ', word: 'உயிர்', meaning: 'Life' },
  { letter: 'உ', word: 'உலகம்', meaning: 'World' },
  { letter: 'ஊ', word: 'ஊதல்', meaning: 'Whistle' },
  { letter: 'ஊ', word: 'ஊஞ்சல்', meaning: 'Swing' },
  { letter: 'ஊ', word: 'ஊசி', meaning: 'Needle' },
  { letter: 'எ', word: 'எலி', meaning: 'Mouse' },
  { letter: 'எ', word: 'எழுத்து', meaning: 'Letter' },
  { letter: 'எ', word: 'எருமை', meaning: 'Buffalo' },
  { letter: 'ஏ', word: 'ஏணி', meaning: 'Ladder' },
  { letter: 'ஏ', word: 'ஏறு', meaning: 'Climb' },
  { letter: 'ஏ', word: 'ஏவல்', meaning: 'Command' },
  { letter: 'ஐ', word: 'ஐந்து', meaning: 'Five' },
  { letter: 'ஐ', word: 'ஐவர்', meaning: 'Five People' },
  { letter: 'ஐ', word: 'ஐயம்', meaning: 'Doubt' },
  { letter: 'ஒ', word: 'ஒன்று', meaning: 'One' },
  { letter: 'ஒ', word: 'ஒளி', meaning: 'Light' },
  { letter: 'ஒ', word: 'ஒழுங்கு', meaning: 'Order' },
  { letter: 'ஓ', word: 'ஓடம்', meaning: 'Boat' },
  { letter: 'ஓ', word: 'ஓது', meaning: 'Recite' },
  { letter: 'ஓ', word: 'ஓடு', meaning: 'Run' },
  { letter: 'ஔ', word: 'ஔவை', meaning: 'Avvai' },
  { letter: 'ஔ', word: 'ஔடதம்', meaning: 'Medicine' },
  { letter: 'ஔ', word: 'ஔவியம்', meaning: 'Envy' }  
];

export const meiLetters: Letter[] = [
  { letter: 'க', word: 'கல்', meaning: 'Stone' },
  { letter: 'கா', word: 'காற்று', meaning: 'Air' },
  { letter: 'கி', word: 'கிளி', meaning: 'Parrot' },
  { letter: 'கீ', word: 'கீரை', meaning: 'Spinach' },
  { letter: 'கு', word: 'குடம்', meaning: 'Pot' },
  { letter: 'கூ', word: 'கூடு', meaning: 'Nest' },
  { letter: 'கெ', word: 'கெட்டி', meaning: 'Strong' },
  { letter: 'கே', word: 'கேள்', meaning: 'Listen' },
  { letter: 'கை', word: 'கைபேசி', meaning: 'Mobile' },
  { letter: 'கொ', word: 'கொடி', meaning: 'Flag' },
  { letter: 'கோ', word: 'கோயில்', meaning: 'Temple' },
  { letter: 'க்', word: 'மூக்கு', meaning: 'Nose' },

  { letter: 'ங்', word: 'பங்கு', meaning: 'Share' },

  { letter: 'ச', word: 'சங்கம்', meaning: 'Association' },
  { letter: 'சா', word: 'சாப்பாடு', meaning: 'Food' },
  { letter: 'சி', word: 'சிறகு', meaning: 'Wing' },
  { letter: 'சீ', word: 'சீப்பு', meaning: 'Comb' },
  { letter: 'சு', word: 'சுற்று', meaning: 'Rotate' },
  { letter: 'சூ', word: 'சூடு', meaning: 'Heat' },
  { letter: 'செ', word: 'செடி', meaning: 'Plant' },
  { letter: 'சே', word: 'சேவை', meaning: 'Service' },
  { letter: 'சை', word: 'சைவம்', meaning: 'Vegetarian' },
  { letter: 'சொ', word: 'சொல்', meaning: 'Word' },
  { letter: 'சோ', word: 'சோறு', meaning: 'Rice' },
  { letter: 'ச்', word: 'பச்சை', meaning: 'Green' },

  { letter: 'ஞா', word: 'ஞாயிறு', meaning: 'Sun' },
  { letter: 'ஞ்', word: 'பஞ்சு', meaning: 'Cotton' },

  { letter: 'ட', word: 'பாடல்', meaning: 'Song' },
  { letter: 'டா', word: 'பட்டாசு', meaning: 'Firecracker' },
  { letter: 'டி', word: 'படி', meaning: 'Step' },
  { letter: 'டு', word: 'மாடு', meaning: 'Cow' },
  { letter: 'டை', word: 'மடை', meaning: 'Dam' },
  { letter: 'ட்', word: 'பட்டு', meaning: 'Silk' },

  { letter: 'ண', word: 'பணம்', meaning: 'Money' },
  { letter: 'ணி', word: 'பணி', meaning: 'Work' },
  { letter: 'ணை', word: 'பண்ணை', meaning: 'Farm' },
  { letter: 'ண்', word: 'மண்', meaning: 'Soil' },

  { letter: 'த', word: 'தலை', meaning: 'Head' },
  { letter: 'தா', word: 'தாத்தா', meaning: 'Grandfather' },
  { letter: 'தி', word: 'நதி', meaning: 'River' },
  { letter: 'தீ', word: 'தீவு', meaning: 'Island' },
  { letter: 'து', word: 'பத்து', meaning: 'Ten' },
  { letter: 'தூ', word: 'தூது', meaning: 'Message' },
  { letter: 'தெ', word: 'தெரு', meaning: 'Street' },
  { letter: 'தே', word: 'தேநீர்', meaning: 'Tea' },
  { letter: 'தை', word: 'உதை', meaning: 'Kick' },
  { letter: 'தொ', word: 'தொடு', meaning: 'Touch' },
  { letter: 'தோ', word: 'தோகை', meaning: 'Tail of a peacock' },
  { letter: 'த்', word: 'பத்து', meaning: 'Ten' },

  { letter: 'ந', word: 'நகை', meaning: 'Jewelry' },
  { letter: 'நா', word: 'நாற்றம்', meaning: 'Smell' },
  { letter: 'நி', word: 'நிலை', meaning: 'Position' },
  { letter: 'நீ', word: 'நீளம்', meaning: 'Length' },
  { letter: 'நு', word: 'நுழை', meaning: 'Enter' },
  { letter: 'நூ', word: 'நூல்', meaning: 'Thread' },
  { letter: 'நெ', word: 'நெற்றி', meaning: 'Forehead' },
  { letter: 'நே', word: 'நேரம்', meaning: 'Time' },
  { letter: 'நொ', word: 'நொறுக்கு', meaning: 'Break' },
  { letter: 'நோ', word: 'நோய்', meaning: 'Disease' },
  { letter: 'ந்', word: 'பந்து', meaning: 'Ball' },

  { letter: 'ப', word: 'பழம்', meaning: 'Fruit' },
  { letter: 'பா', word: 'பாடல்', meaning: 'Song' },
  { letter: 'பி', word: 'பின்பு', meaning: 'Behind' },
  { letter: 'பீ', word: 'பீடு', meaning: 'Pride' },
  { letter: 'பு', word: 'புதர்', meaning: 'Bush' },
  { letter: 'பூ', word: 'பூங்கொடி', meaning: 'Flower' },
  { letter: 'பெ', word: 'பெண்மை', meaning: 'Femininity' },
  { letter: 'பே', word: 'பேச்சு', meaning: 'Speak' },
  { letter: 'பை', word: 'பணப்பை', meaning: 'Wallet' },
  { letter: 'பொ', word: 'பொது', meaning: 'Common' },
  { letter: 'போ', word: 'போர்', meaning: 'War' },
  { letter: 'ப்', word: 'பாப்பா', meaning: 'Baby' },

  { letter: 'ம', word: 'மரம்', meaning: 'Tree' },
  { letter: 'மா', word: 'மாலை', meaning: 'Evening' },
  { letter: 'மி', word: 'மின்னல்', meaning: 'Lightning' },
  { letter: 'மீ', word: 'மீன்', meaning: 'Fish' },
  { letter: 'மு', word: 'முகம்', meaning: 'Face' },
  { letter: 'மூ', word: 'மூக்கு', meaning: 'Nose' },
  { letter: 'மெ', word: 'மெத்தை', meaning: 'Mattress' },
  { letter: 'மே', word: 'மேடை', meaning: 'Stage' },
  { letter: 'மை', word: 'மைதானம்', meaning: 'Ground' },
  { letter: 'மொ', word: 'மொட்டு', meaning: 'Bud' },
  { letter: 'மோ', word: 'மோதி', meaning: 'Dispute' },
  { letter: 'ம்', word: 'மரம்', meaning: 'Tree' },

  { letter: 'யா', word: 'யானை', meaning: 'Elephant' },
  { letter: 'யு', word: 'யுகம்', meaning: 'Era' },
  { letter: 'ய்', word: 'வாய்', meaning: 'Mouth' },

  { letter: 'ர்', word: 'பார்', meaning: 'See' },
  { letter: 'ல்', word: 'பால்', meaning: 'Milk' },

  { letter: 'வ', word: 'வண்டு', meaning: 'Beetle' },
  { letter: 'வா', word: 'வாத்து', meaning: 'Duck' },
  { letter: 'வி', word: 'விழி', meaning: 'Eye' },
  { letter: 'வீ', word: 'வீடு', meaning: 'House' },
  { letter: 'வெ', word: 'வெள்ளம்', meaning: 'Flood' },
  { letter: 'வே', word: 'வேல்', meaning: 'Spear' },
  { letter: 'வை', word: 'பறவை', meaning: 'Bird' },
  { letter: 'வ்', word: 'கவ்வு', meaning: 'Grab' },

  { letter: 'ழ', word: 'பழம்', meaning: 'Fruit' },
  { letter: 'ழா', word: 'விழா', meaning: 'Celebration' },
  { letter: 'ழி', word: 'பழி', meaning: 'Blame' },
  { letter: 'ழு', word: 'வழு', meaning: 'Slip' },
  { letter: 'ழை', word: 'வாழை', meaning: 'Banana' },
  { letter: 'ழ்', word: 'தமிழ்', meaning: 'Tamil' },

  { letter: 'ள', word: 'களம்', meaning: 'Field' },
  { letter: 'ளா', word: 'வளாகம்', meaning: 'Compound' },
  { letter: 'ளி', word: 'குளிர்', meaning: 'Cold' },
  { letter: 'ளு', word: 'வளு', meaning: 'Strength' },
  { letter: 'ளை', word: 'வளையல்', meaning: 'Bangle' },
  { letter: 'ள்', word: 'பள்ளி', meaning: 'School' },

  { letter: 'ற', word: 'பறவை', meaning: 'Bird' },
  { letter: 'றா', word: 'புறா', meaning: 'Bird' },
  { letter: 'றி', word: 'பறி', meaning: 'Pluck' },
  { letter: 'று', word: 'காற்று', meaning: 'Wind' },
  { letter: 'றை', word: 'பறை', meaning: 'Drum' },
  { letter: 'ற்', word: 'கற்க', meaning: 'Learn' },

  { letter: 'ன', word: 'வானம்', meaning: 'Sky' },
  { letter: 'னி', word: 'கனிவு', meaning: 'Compassion' },
  { letter: 'னை', word: 'மனை', meaning: 'House' },
  { letter: 'ன்', word: 'மான்', meaning: 'Deer' }
];